// extracted by mini-css-extract-plugin
export default {"main":"SomethingWentWrong_main__KujCc","topInfo":"SomethingWentWrong_topInfo__EdbDC","infoText":"SomethingWentWrong_infoText__TXUEo"};